import React, { useState, useEffect } from 'react';
import { Row, Col, Skeleton } from 'antd';
import moment from 'moment';

import { durationTime } from '../../../../helpers/formatarDataFila';
import * as S from './styles';

export function HeaderDetalhamento({ solicitacao, loading = false }) {
  const [dataHeader, seDataHeader] = useState(null);

  useEffect(() => {
    seDataHeader({
      tempoAtendimento: moment(
        durationTime(
          solicitacao?.dataInicializacao,
          solicitacao?.dataFinalizacao
        )
      ).format('HH:mm:ss'),
      dataInicializacao:
        (solicitacao?.dataInicializacao &&
          moment(solicitacao?.dataInicializacao).format(
            'DD/MM/YYYY [às] HH:mm:ss'
          )) ||
        '',
      dataSolicitacao:
        (solicitacao?.dataSolicitacao &&
          moment(solicitacao?.dataSolicitacao).format(
            'DD/MM/YYYY [às] HH:mm:ss'
          )) ||
        '',
    });
  }, [solicitacao]);
  return (
    <Col span={24}>
      <Row>
        {loading && (
          <>
            <Col span={6}>
              <Skeleton
                active
                size="small"
                loading={loading}
                paragraph={{ rows: 0 }}
              />
            </Col>
            <Col span={6}>
              <Skeleton
                active
                size="small"
                loading={loading}
                paragraph={{ rows: 0 }}
              />
            </Col>
            <Col span={6}>
              <Skeleton
                active
                size="small"
                loading={loading}
                paragraph={{ rows: 0 }}
              />
            </Col>
          </>
        )}

        {!loading && (
          <Row gutter={16}>
            <Col>
              <S.TextHeader color="#828282">
                Entrada da solicitação:
              </S.TextHeader>
              <S.TextHeader>{dataHeader?.dataSolicitacao || '-'}</S.TextHeader>
            </Col>
            <Col>
              <S.TextHeader color="#828282">
                Início do atendimento:
              </S.TextHeader>
              <S.TextHeader>
                {dataHeader?.dataInicializacao || '-'}
              </S.TextHeader>
            </Col>
            <Col>
              <S.TextHeader color="#828282">
                Tempo de Atendimento:
              </S.TextHeader>
              <S.TextHeader>{dataHeader?.tempoAtendimento || '-'}</S.TextHeader>
            </Col>
          </Row>
        )}
      </Row>
    </Col>
  );
}
